// 接口域名取自根目录 .env.[mode] 文件，切换环境改配置文件即可，无需再修改本文件
// npm run serve -> .env.development / npm run build:staging -> .env.staging / npm run build -> .env.production
var BaseUrl = process.env.VUE_APP_BASE_URL || 'https://b2b.huayizhiyao.cn';
// 兼容配置值末尾多写的 "/"
BaseUrl = BaseUrl.replace(/\/+$/, '');
let compartment_config = {
	// api请求地址
	baseUrl: BaseUrl+'/',
	// 分仓地址
	warehouse_host:sessionStorage.getItem("warehouse_host")||BaseUrl,
	// 图片域名
	imgDomain: BaseUrl+'/',
	// 前端域名
	webDomain: BaseUrl+'/',
	// 腾讯地图key
    mpKey: "",
	// 客服
    webSocket: "",
	// 本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
    pingInterval: 1500,
	// 客服地址
    keFuUrl: "",
    // 是否允许分仓与默认版本之间切换
    allowVersion_switch:false
};
export default compartment_config;